export const NEWBUILDING_MONTHLY_PAYMENT = 'newbuilding_monthly_payment_desktop';

export const EXPERIMENTS = [NEWBUILDING_MONTHLY_PAYMENT];
